import type { FC } from 'react';
import React from 'react';
import { useDrag } from 'react-dnd';
import { Box } from '@mui/material';

import { DRAG_ITEM_TYPES } from 'src/constants/dragItem';
import type { ModuleOrPlanActionOrgUnit } from 'src/types/orgUnit';
import OrgUnitLabel from 'src/components/common/OrgTree/components/OrgTreeItem/components/OrgUnitLabel';

export interface DraggableOrgUnitLabelProps {
  orgUnit: ModuleOrPlanActionOrgUnit;
}

const DraggableOrgUnitLabel: FC<DraggableOrgUnitLabelProps> = ({ orgUnit }) => {
  const [{ isDragging }, drag] = useDrag({
    type: DRAG_ITEM_TYPES.ORG_UNIT,
    item: {
      dragSourceType: DRAG_ITEM_TYPES.ORG_UNIT,
      orgUnitId: orgUnit.org_unit_id,
      title: orgUnit.name,
      type: DRAG_ITEM_TYPES.ORG_UNIT,
      variableId: DRAG_ITEM_TYPES.ORG_UNIT,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <Box
      sx={{
        display: 'inline',
        ...(isDragging ? { opacity: 0.2 } : { opacity: 'unset' }),
      }}
      data-test-id="draggable-org-unit"
      ref={drag}
    >
      <OrgUnitLabel orgUnit={orgUnit} />
    </Box>
  );
};

export default DraggableOrgUnitLabel;
